// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ty5Pc","headline-wrapper":"_2F7_k","explained-wrapper":"Kdozi","explained-title":"_1SLlN","cards-count-title":"_3cWxG"};